import get from "lodash/get";
import omit from "lodash/omit";
import PropTypes from "prop-types";
import isEqual from "lodash/isEqual";
import React from "react";

import { S3 } from "../../constants";
import Avatar from "../avatar";
import SvgIcon from "../SvgIcon";
const SIZE = 180;

class AvatarInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleReset = this.handleReset.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.state = {
      modified: false,
      src: undefined,
    };
    this.fileInput = null;
    this.setFileInputRef = (element) => {
      this.fileInput = element;
    };
  }

  handleReset(e) {
    if (e && e.target && e.target.hasAttribute("data-noreset")) return;
    this.setState({ src: undefined, modified: false });
  }

  handleChange({ target }) {
    if (!target.value) {
      return this.setState({ modified: true, src: undefined });
    }

    // Read uploaded file as data uri, crop/resize it and display it.
    const fileReader = new FileReader();
    const file = target.files[0];

    fileReader.readAsDataURL(file);
    fileReader.addEventListener(
      "load",
      function load() {
        fileReader.removeEventListener("load", load);

        // Setup canvas
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = SIZE;
        canvas.height = SIZE;

        // Setup image
        const img = document.createElement("img");
        img.src = fileReader.result;

        this.setState({ modified: true, src: img.src });
        if (this.props.handleSrc) this.props.handleSrc(img.src);
      }.bind(this)
    );
    if (this.props.handleChangeCallback)
      this.props.handleChangeCallback(target);
    const buttonId = this.props.customId
      ? this.props.customId
      : "edit-profile-button";
    const buttonElement = document.getElementById(buttonId);
    if (buttonElement) {
      buttonElement.click();
    }
  }

  handleEditClick(e) {
    e.preventDefault();
    if (this.fileInput) this.fileInput.click();
  }

  componentDidMount() {
    const form = get(this, "fileInput.form");
    if (!form) return;
    form.addEventListener("reset", this.handleReset);
    form.addEventListener("submit", this.handleReset);
  }

  componentWillUnmount() {
    const form = get(this, "fileInput.form");
    if (!form) return;
    form.removeEventListener("reset", this.handleReset);
    form.removeEventListener("submit", this.handleReset);
  }

  componentWillReceiveProps(next) {
    if (!isEqual(next.defaultValue, this.props.defaultValue)) {
      this.setState({ src: undefined, modified: false });
    }
  }

  render() {
    const { locals } = this.context;
    const {
      name,
      imageSize,
      editIcon,
      editText = "",
      imgPath = "",
      useBgImg = false,
      overlay = false,
      onlyMobile = false,
      onlyDesktop = false,
    } = this.props;
    const { modified, src } = this.state;
    const [firstName, lastName] = get(locals, "activeUser.name", "").split(
      / +/
    );

    let defaultValue = undefined;
    if (this.props.defaultValue) {
      defaultValue = this.props.defaultValue.s3Path;
    }

    const url = src
      ? src
      : defaultValue
      ? `${S3.PATH}${defaultValue}`
      : imgPath;

    return (
      <>
        <label
          className={`avatar-input${onlyMobile ? " only-show-mobile" : ""}${
            onlyDesktop ? " mobile-hidden" : ""
          }`}
          for={name}
        >
          <Avatar
            size={imageSize || SIZE}
            className={`image${onlyMobile ? " only-show-mobile" : ""}${
              onlyDesktop ? " mobile-hidden" : ""
            }`}
            url={url}
            useBgImg={useBgImg}
            overlay={overlay}
            height="auto"
          />

          {editIcon && (
            <div className="edit-button" onClick={this.handleEditClick}>
              <span className="edit-text">{editText}</span>
              <img className="edit-icon" src={editIcon} />
            </div>
          )}
          <div className="action-buttons">
            <button data-button-type="outline" onClick={this.handleEditClick}>
              <span className="mobile-hidden">Change Photo</span>
              <SvgIcon
                src="/img/new-icons/edit-pencil.svg"
                noFilterOnLight={true}
                classNames="only-show-mobile"
              />
            </button>
            {/* <button
              data-button-type="secondary"
              onClick={() => console.log("deleting")}
            >
              <SvgIcon
                src="/img/new-icons/red-trash.svg"
                noFilterOnLight={true}
              />
            </button> */}
          </div>
        </label>
        <input
          key={defaultValue}
          ref={this.setFileInputRef}
          className="file-input"
          {...omit(this.props, [
            "imageSize",
            "editIcon",
            "editText",
            "imgPath",
            "useBgImg",
            "overlay",
            "handleChangeCallback",
          ])}
          type="file"
          accept="image/*"
          name={name}
          required={!defaultValue && this.props.required}
          onChange={this.handleChange}
          defaultValue={undefined}
        />
      </>
    );
  }
}

AvatarInput.defaultProps = {
  defaultValue: {},
};

AvatarInput.contextTypes = { locals: PropTypes.object };

export default AvatarInput;
